import UserCard from "@/components/UserCard";
import VTag from "@/components/VTag";
import ListHeader from "@/components/ListHeader";
export default {
  components: {
    UserCard,
    VTag,
    ListHeader
  },
  props: {
    appointments: Array
  },
  data() {
    return {
      loading: false
    };
  }
};
